'use client';

import { Image, Typography } from '@/components/atoms';
import { cn } from '@/lib/utils/tailwind';

import type { CarouselArtCardProps } from '@/components/molecules/CarouselArtCard/types';

export const CarouselArtCard: React.FC<CarouselArtCardProps> = ({
  id,
  title,
  image,
  isActive,
}) => {
  return (
    <div
      key={id}
      className="w-full h-full flex flex-col justify-center items-center"
    >
      <Image
        src={image}
        alt={title}
        width={isActive ? 300 : 220}
        height={isActive ? 280 : 210}
        className={cn(
          'w-full h-auto object-contain rounded-none',
          isActive
            ? 'max-w-[300px] max-h-[280px]'
            : 'max-w-[220px] max-h-[210px]',
        )}
      />
      {isActive && (
        <div className="mt-2 w-full">
          <Typography.Text
            weight="regular"
            size="lg"
            color="--color-text-primary"
            className="text-center"
          >
            {title}
          </Typography.Text>
        </div>
      )}
    </div>
  );
};
